import React from "react"
import { useShowValidationResult } from "./useShowValidationResult";
import ValidTicketResult from "./ValidTicketResult";
import InvalidTicketResult from "./InvalidTicketResult";
import ScannedTicketResult from "./ScannedTicketResult";

const SCAN_VALID = 'scan_valid'
const SCANNED_BEFORE = 'scanned_before'
const SCAN_INVALID = 'scan_invalid'

const ValidationResult = (props) => {

    const {scan, onClickNext} = props

    const {showValidationResult} = useShowValidationResult()

    return (
        <>
            {showValidationResult &&
                <>
                    {scan.status === SCAN_VALID &&
                        <ValidTicketResult scan={scan} onClickNext={onClickNext}/>
                    }

                    {scan.status === SCANNED_BEFORE &&
                        <ScannedTicketResult scan={scan} onClickNext={onClickNext}/>
                    }

                    {scan.status === SCAN_INVALID &&
                        <InvalidTicketResult scan={scan} onClickNext={onClickNext}/>
                    }
                </>
            }
        </>
    )
}

export default ValidationResult
